//
export default {
  //图片上传
  UPLOAD_IMAGE: '/jcnapi/common/uploadPicture',
  UPLOAD_LOCAL_IMAGE: '/jcnapi/common/uploadLocalPicture',
  UPLOAD_LOCAL_FILE: '/jcnapi/common/uploadFile',
  //文件上传
  SET_DOMAIN: '/jcnapi/system/domain/setDomain',
  GET_DOMAIN: '/jcnapi/system/domain/getDomain',
  DEMOLIST: '/static/data/list.json'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/common/index.js